export default __webpack_public_path__ + "static/threads-dd24cb4574300376d148be3350a045ac.jpg";